<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 企业名单
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>
                <el-input v-model='query.name' placeholder='企业名称' class='handle-input mr10'
                          style='width: 140px;margin-right: 20px'></el-input>

                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button type='primary' icon='el-icon-plus' @click='addUser'>添加</el-button>


            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column label='企业名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label='负责人' align='center'>
                    <template slot-scope='scope'>{{ scope.row.concatName }}</template>
                </el-table-column>
                <el-table-column label='联系方式' align='center'>
                    <template slot-scope='scope'>{{ scope.row.concatPhone }}</template>
                </el-table-column>

                <el-table-column label='地理位置' align='center'>

                    <template slot-scope='scope'>{{ scope.row.addressDetails }}</template>
                </el-table-column>

                <!--                <el-table-column label='报警阈值(M)' align='center'>-->
                <!--                    <template slot-scope='scope'>{{ scope.row.threshold }}</template>-->
                <!--                </el-table-column>-->

                <el-table-column label='是否合作' align='center'>
                    <template slot-scope='scope'>{{ scope.row.isCollaborate }}</template>
                </el-table-column>
                <el-table-column label='余额' align='center'>
                    <template slot-scope='scope'>{{ scope.row.money / 100 }}</template>
                </el-table-column>
                <el-table-column label='备注信息' align='center'>
                    <template slot-scope='scope'>{{ scope.row.remark }}</template>
                </el-table-column>
                <el-table-column prop='createTime' label='添加时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>

                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑查看
                        </el-button>
                        <el-button
                            type='text'

                            @click='handleReCharge(scope.$index, scope.row)'
                        >充值
                        </el-button>
                        <el-button
                            type='text'
                            @click='handleAlarm(scope.$index, scope.row)'
                        >生成预警
                        </el-button>

                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <el-dialog title='充值' :visible.sync='reChargeVisible' width='40%'>

            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='企业名称'>
                    <el-input v-model='form.name' disabled></el-input>
                </el-form-item>
                <el-form-item label='当前金额'>
                    <el-input v-model='form.money/100' maxlength='11' disabled></el-input>
                </el-form-item>
                <el-form-item label='当前金额'>
                    <el-input v-model='form.optMoney' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='充值时间'>
                    <el-date-picker
                        v-model="dateRecharge"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>


            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='reChargeVisible = false'>取 消</el-button>
                <el-button type='primary' @click='reChargeHttp'>确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title='编辑企业' :visible.sync='editVisible' width='40%'>

            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='企业名称'>
                    <el-input v-model='form.name'></el-input>
                </el-form-item>
                <el-form-item label='负责人'>
                    <el-input v-model='form.concatName' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='联系电话'>
                    <el-input v-model='form.concatPhone' maxlength='11'></el-input>
                </el-form-item>
                <!--                <el-form-item label='报警阈值(M)'>-->
                <!--                    <el-input v-model='form.threshold' maxlength='11'></el-input>-->
                <!--                </el-form-item>-->
                <el-form-item label='地理位置'>
                    <div>
                        <el-button type='text' @click='clickSelectAddress()'>点击选择位置</el-button>
                        <el-input v-model='form.addressDetails' disabled style='margin-top: 10px'></el-input>

                    </div>

                </el-form-item>


                <el-form-item label='备注'>
                    <el-input v-model='form.remark' maxlength='11'></el-input>
                </el-form-item>

                <!--                <el-form-item label='添加人'>-->
                <!--                    <el-input v-model='form.createName' maxlength='11' disabled></el-input>-->
                <!--                </el-form-item>-->


            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='添加企业' :visible.sync='addVisible' width='40%' :close-on-click-modal='false'>


            <el-form ref='form' :model='form' label-width='120px'>

                <el-form-item label='企业名称'>
                    <el-input v-model='createForm.name' ></el-input>
                </el-form-item>
                <el-form-item label='负责人'>
                    <el-input v-model='createForm.concatName' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='联系方式'>
                    <el-input v-model='createForm.concatPhone' maxlength='11'></el-input>
                </el-form-item>

                <el-form-item label='地理位置'>
                    <div>
                        <el-button type='text' @click='clickSelectAddress()'>点击选择位置</el-button>
                        <el-input v-model='createForm.addressDetails' disabled style='margin-top: 10px'></el-input>

                    </div>

                </el-form-item>
                <el-form-item label='备注信息'>
                    <el-input v-model='createForm.remark'></el-input>
                </el-form-item>


            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp' :loading='submitLoading'
                           :disabled='submitLoading'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='选择地址' :visible.sync='selectAddressVisible' width='80%' :close-on-click-modal='false'>
            <div
                style='display: flex;margin-top: 10px;margin-bottom: 10px;text-align: center;justify-content: space-between'>
                <div style='font-size: 24px;text-align: center;height: 30px;line-height: 30px;color: #333333'>
                    您选中的地址:{{ addressDetails }}
                </div>

                <el-button type='primary' @click='selectAddressVisible=false'>保存位置</el-button>
            </div>

            <div style='display: flex;margin-top: 10px;margin-bottom: 10px'>
                <el-input v-model='keyword' placeholder='要搜索的地理位置信息'></el-input>
            </div>

            <baidu-map class='map' :center='{lng: 121.23, lat: 28.13}' :zoom='15' @click='getLocation'>
                <bm-local-search :keyword='keyword' :auto-viewport='false'></bm-local-search>
                <bm-navigation anchor='BMAP_ANCHOR_TOP_RIGHT'></bm-navigation>
                <bm-geolocation anchor='BMAP_ANCHOR_BOTTOM_RIGHT' :showAddressBar='true'
                                :autoLocation='true'></bm-geolocation>
                <bm-marker :position="markerPoint" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" ></bm-marker>
            </baidu-map>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';
import { baseUrl } from '@/utils/nHttp';
import { Loading } from 'element-ui';

export default {
    name: 'basetable',
    data() {
        return {
            dateRecharge:"",
            addressDetails:"",
            submitLoading: false,
            longitude: '',
            latitude: '',
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10,
                licensePlate:""
            },
            queryService: {
                name: '',
                pageIndex: 1,
                pageSize: 10000
            },
            memberVisible: false,
            tableData: [],
            multipleSelection: [],
            delList: [],
            cardPwdType: '0',
            editVisible: false,
            reChargeVisible: false,
            addVisible: false
            ,
            selectAddressVisible: false,
            createForm: {
                addressDetails: ''
            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: [],
            editValue: [],
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue: '',
            areaOptions: [],
            areaValue: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            serviceProviderOptions: [],
            serviceProviderValue: [],
            lastEnterpriseOptions: [],
            lastEnterpriseValue: '',
            memberStartTimeStr: '',
            memberEndTimeStr: '',
            location: '玉环县',
            keyword: '',
            markerPoint:{lng: 0, lat: 0}


        };
    },
    created() {
        this.getData();
        this.getProvince();
        // this.getCity();

    },

    watch: {

        //监听内容
        provinceValue() {
            let that = this;
            this.areaValue = '';
            this.cityValue = '';
            let param = { 'id': this.provinceValue };
            this.http.get('user/getCity', param).then(res => {
                    if (res.code == 0) {
                        that.cityOptions = [{ 'id': '', 'name': '请选择市' }, ...res.data];
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });

            console.log('provinceValue' + this.provinceValue);
        },
        cityValue() {
            let that = this;
            let param = { 'id': this.cityValue };
            this.areaValue = '';
            this.http.get('user/getAreaById', param).then(res => {
                    if (res.code == 0) {
                        that.areaOptions = [{ 'id': '', 'name': '请选择区' }, ...res.data];
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        areaValue() {
            let that = this;

        }
    },
    methods: {
        handleRemove(file) {

        },
        getLocation(e) {
            this.longitude = e.point.lng;
            this.latitude = e.point.lat;
            this.markerPoint.lng= e.point.lng
            this.markerPoint.lat= e.point.lat
            this.infoWindowShow = true;
            this.getLongitudeAndLatitude();
        },
        getLongitudeAndLatitude() {
            let that = this;
            let param = { 'longitude': this.longitude, 'latitude': this.latitude };
            this.http.get('qwpenterprise/getLongitudeAndLatitude', param).then(res => {
                    console.log(JSON.stringify(res));
                    if (res.code == 0) {
                        that.createForm.addressDetails = res.data;
                        that.addressDetails = res.data;
                        console.log(that.createForm.addressDetails)

                    }
                },
                err => {

                });
        }
        ,
        handlePreview(file) {

        },
        clickSelectAddress() {
            this.selectAddressVisible = true;
        },
        getProvince() {
            let that = this;
            console.log(this.query.pageSize);
            let param = {};
            this.http.get('user/getProvince', param).then(res => {
                    if (res.code == 0) {


                        that.provinceOptions = [{ 'id': '', 'name': '请选择省份' }, ...res.data];
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        beforeAvatarUpload(file) {
            console.log('hello');
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        uploadFileLogo(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.logoUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    this.form['logoUrlList'] = [{ 'url': that.form.logoUrl }];
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileEnvironmentUrl(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.environmentUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    this.form['environmentUrlList'] = [{ 'url': that.form.environmentUrl }];
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFilebusinessLicenseUrl(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.businessLicenseUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    this.form['businessLicenseUrlList'] = [{ 'url': that.form.businessLicenseUrl }];
                }
            }, err => {
                // 出现错误时的处理
            });
        }

        ,
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';

            msg = '确定要审批通过吗？';
            params = { 'id': row.id, 'status': 1 };

//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('qwpenterprise/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        getCity() {

        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;

            this.getData();

        }
        ,
        getData() {
            let that = this;
            console.log(this.query.pageSize);
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;
            this.query.areaId = this.areaValue;
            this.http.get('/qwpenterprise/getList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');
                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.post('/qwpenterprise/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.longitude = '';
            this.latitude = '';
            this.addVisible = true;
            this.form = {};
            this.createForm = {};

        },

        addUserHttp() {
            console.log('addUserHttp');
            this.submitLoading = true;
            let that = this;
            this.createForm.latitude = this.latitude;

            this.createForm.longitude = this.longitude;
            this.http.postToken('qwpenterprise/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');

                }
                // 设置一个1000毫秒后执行的定时任务
                setTimeout(function() {
                    that.submitLoading = false;
                }, 1000);


            });
        }
        ,
        memberHttp() {
            if (typeof this.memberStartTimeStr == 'string') {
                this.memberStartTimeStr = '';
                this.memberEndTimeStr = '';
                this.$message.error('开始时间不能为空,请重新选择开始和结束时间');
                return;
            }
            if (typeof this.memberEndTimeStr == 'string') {
                this.memberStartTimeStr = '';
                this.memberEndTimeStr = '';
                this.$message.error('结束时间不能为空,请重新选择开始和结束时间');
                return;
            }
            let that = this;

            var Y = this.memberStartTimeStr.getFullYear() + '-';
            var M = (this.memberStartTimeStr.getMonth() + 1 < 10 ? '0' + (this.memberStartTimeStr.getMonth() + 1) : this.memberStartTimeStr.getMonth() + 1);
            var D = '-' + this.memberStartTimeStr.getDate();

            this.memberStartTimeStr = Y + M + D;
            // this.form.provinceId = this.form.value[0];
            // this.form.cityId = this.form.value[1];
            // this.form.cardPwdType = this.cardPwdType;
            Y = this.memberEndTimeStr.getFullYear() + '-';
            M = (this.memberEndTimeStr.getMonth() + 1 < 10 ? '0' + (this.memberEndTimeStr.getMonth() + 1) : this.memberEndTimeStr.getMonth() + 1);
            D = '-' + this.memberEndTimeStr.getDate();
            this.memberEndTimeStr = Y + M + D;

            let params = {};
            params.id = this.form.id;
            params.memberEndTimeStr = this.memberEndTimeStr;
            params.memberStartTimeStr = this.memberStartTimeStr;
            params.memberType = '0';
            this.memberStartTimeStr = '';
            this.memberEndTimeStr = '';
            this.http.post('qwpenterprise/memberSet', params).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.memberVisible = false;
                    that.$message.success('编辑成功');
                }
            });
        },
        editHttp() {
            console.log(this.form);

            let that = this;
            this.form.latitude = this.latitude;
            this.form.longitude = this.longitude;

            this.http.post('qwpenterprise/updateInfo', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }
            });
        }
        ,
        reChargeHttp() {
            console.log(this.form);

            let that = this;
            if (this.dateRecharge==''){
                this.form.rechargeTime=''
            }else {
                this.form.rechargeTime =  formatDate(this.dateRecharge);
            }

            this.http.postToken('qwpenterprise/reCharge', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.reChargeVisible = false;
                    that.$message.success('充值成功');
                }
            });
        },
        handleReCharge(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.dateRecharge=''
            this.reChargeVisible = true;
        },
        handleAlarm(index, row) {
            this.idx = index;
            let params={}
            let that = this;
            params.enterpriseId = row.id
            this.$confirm("确定要生成预警吗", '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('Task/addTaskList', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.longitude = this.form.longitude;
            this.latitude = this.form.longitude;


            this.form.value = [row.provinceId + '', row.cityId + ''];
            this.form.options = this.options;
            this.form.proCityArea = row.provinceName + '|' + row.cityName + '' + '|' + row.areaName;
            if (typeof row.environmentUrl != 'null') {
                this.form['environmentUrlList'] = [{ 'url': row.environmentUrl }];
            }
            if (typeof row.businessLicenseUrl != 'null') {
                this.form['businessLicenseUrlList'] = [{ 'url': row.businessLicenseUrl }];
            }
            if (typeof row.logoUrl != 'null') {
                this.form['logoUrlList'] = [{ 'url': row.logoUrl }];
            }
            this.serviceProviderValue = row.serviceProvideId;
            this.lastEnterpriseValue = row.enterpriseId;
            this.cardPwdType = this.form.cardPwdType + '';
            this.editVisible = true;
        },
        handleMember(index, row) {
            this.idx = index;
            this.memberEndTimeStr = '';

            this.memberStartTimeStr = '';
            this.form = JSON.parse(JSON.stringify(row));
            this.memberVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.map {
    width: 100%;
    height: 760px;
}
</style>
